import { Stack } from "@mantine/core"
import { LabelWithTooltip, TagsInput } from "@tfg/ui"

import { FormFieldConfig } from "~/pages/Admin/components/TypesForm"

export const TagsInputField = (fields: FormFieldConfig, form: any) => (
  <Stack gap="var(--mantine-spacing-xxs)">
    {fields.tooltip && (
      <LabelWithTooltip
        label={fields.label}
        hoverHelperText={fields.tooltip}
        justify="space-between"
        fw={600}
        withAsterisk={fields.required ?? false}
      />
    )}
    <TagsInput
      key={fields.name}
      label={!fields.tooltip ? fields.label : undefined}
      labelProps={{
        fz: "xs",
        fw: 600,
      }}
      size="xs"
      classNames={fields.customClass}
      clearable
      styles={{
        pill: {
          backgroundColor: "var(--mantine-color-primary-4)",
          color: "var(--mantine-color-white)",
        },
      }}
      {...form.getInputProps(fields.name)}
      onChange={(value) => {
        form.setFieldValue(fields.name, value)
        form.validateField(fields.name)
      }}
      data={fields.options?.map((option) => ({
        label: option.label,
        value: option.value,
      }))}
    />
  </Stack>
)
